"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _url = _interopRequireDefault(require("url"));
var _xss = _interopRequireDefault(require("xss"));
var _logger = _interopRequireDefault(require("./logger"));
/*
returns true when value passes xss checks, or false otherwise
*/

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function value(search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}

// sql regex reference: http://www.symantec.com/connect/articles/detection-sql-injection-and-cross-site-scripting-attacks
var sql_meta = new RegExp('(%27)|(\')|(--)|(%23)', 'i');
//eslint-disable-next-line no-control-regex
var sql_meta2 = new RegExp('((%3D)|(=))[^\n]*((%27)|(\')|(--)|(%3B)|(;))', 'i');
var sql_typical = new RegExp('w*((%27)|(\'))((%6F)|o|(%4F))((%72)|r|(%52))', 'i');
var sql_union = new RegExp('((%27)|(\'))union', 'i');
var hasSql = function hasSql(value, key) {
  if (value === null || value === undefined) {
    return {
      value: false
    };
  }
  if (sql_meta.test(value) && key !== 'code_challenge') {
    return {
      value: true,
      reason: 'sql-regex1'
    };
  }
  if (sql_meta2.test(value)) {
    return {
      value: true,
      reason: 'sql-regex2'
    };
  }
  if (sql_typical.test(value)) {
    return {
      value: true,
      reason: 'sql-regex-typical'
    };
  }
  if (sql_union.test(value)) {
    return {
      value: true,
      reason: 'sql-regex-union'
    };
  }
  return {
    value: false
  };
};
var doCheck = function doCheck(value, key, doUrlSpecificChecks) {
  if (!value) {
    return {
      value: true
    };
  }
  var tOf = (0, _typeof2.default)(value);
  if (tOf === 'number' || tOf === 'boolean') {
    return {
      value: true
    };
  }
  if (tOf !== 'string') {
    return {
      value: false,
      reason: 'not-string'
    };
  }
  if (doUrlSpecificChecks) {
    try {
      // eslint-disable-next-line no-useless-escape
      var stripped = value.replace(/[\s\r\n\t]/g, '').replace(/\%20/g, '');
      if (stripped.startsWith('//')) {
        return {
          value: false,
          reason: 'startsWith[//]'
        };
      }
      if (value === 'concurmobile://setsession') {
        return {
          value: true
        };
      }
      var parsedUrl = _url.default.parse(stripped);
      if (parsedUrl && parsedUrl.host !== null) {
        return {
          value: false,
          reason: 'host'
        };
      }

      // non-absolute path
      if (value[0] !== '/') {
        return {
          value: false,
          reason: 'non-absolute-path'
        };
      }
      if (value.match(/[\t\r\n]+/)) {
        return {
          value: false,
          reason: 'space'
        };
      }
      //eslint-disable-next-line no-empty
    } catch (err) {}
  }
  var filtered = (0, _xss.default)(value);
  if (filtered !== value) {
    return {
      value: false,
      reason: 'filtered'
    };
  }
  var sqlResult = hasSql(value, key);
  return {
    value: !sqlResult.value,
    reason: sqlResult.reason
  };
};
var _default = exports.default = function _default(value) {
  var doUrlSpecificChecks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var req = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var res = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var key = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var result = doCheck(value, key, doUrlSpecificChecks);
  if (!result.value) {
    _logger.default.info({
      req: req,
      res: res,
      category: 'nui-auth',
      subcategory: 'xss-check',
      description: "Not safe: ".concat(encodeURIComponent(value), ", urlCheck: ").concat(doUrlSpecificChecks, ", reason: ").concat(result.reason, ", key: ").concat(key)
    });
  }
  return result.value;
};